<template>
    <div class="manual-detail-demo" aria-hidden="true">
        <p v-if="!sections.length" class="manual-detail-demo__empty">{{ emptyText }}</p>
        <template v-else>
            <fieldset
                v-for="(section, index) in sections"
                :key="index"
                class="manual-detail-demo__fieldset"
                :class="
                    section.title
                        ? 'rounded bg-brand-50 dark:bg-brand-900 ring-2 ring-brand-100 dark:ring-brand-800'
                        : 'manual-detail-demo__fieldset--plain'
                "
            >
                <legend
                    v-if="section.title"
                    class="rounded bg-white dark:bg-neutral-950 ring-2 ring-brand-100 dark:ring-brand-800 ml-4 px-3 py-1 text-xs font-bold uppercase"
                >
                    {{ section.title }}
                </legend>
                <div
                    v-for="row in section.rows"
                    :key="row.label"
                    class="manual-detail-demo__row"
                    :class="{ 'manual-detail-demo__row--checkbox': row.type === 'checkbox' }"
                >
                    <span class="manual-detail-demo__label">{{ row.label }}</span>
                    <input v-if="row.type === 'checkbox'" type="checkbox" :checked="row.checked" disabled />
                    <span v-else class="manual-detail-demo__input bg-white dark:bg-neutral-900">{{ row.value }}</span>
                </div>
            </fieldset>
        </template>
    </div>
</template>

<script setup lang="ts">
interface DemoRow {
    label: string;
    value?: string;
    type?: 'text' | 'checkbox';
    checked?: boolean;
}

defineProps<{
    sections: Array<{ title: string | null; rows: DemoRow[] }>;
    emptyText: string;
}>();
</script>

<style scoped>
.manual-detail-demo {
    pointer-events: none;
    user-select: none;
}
.manual-detail-demo__empty {
    opacity: 0.6;
    font-size: 0.875rem;
    border: 1px solid rgba(128, 128, 128, 0.25);
    border-radius: 0.5rem;
    padding: 0.75rem 1rem;
}
.manual-detail-demo__fieldset {
    padding: 0.5rem 0.75rem 0.625rem;
    margin: 0 0 1.125rem;
}
.manual-detail-demo__fieldset--plain {
    border: 1px solid rgba(128, 128, 128, 0.25);
    border-radius: 0.375rem;
}
.manual-detail-demo__row {
    display: grid;
    grid-template-columns: minmax(6.5rem, 38%) 1fr;
    gap: 0.25rem 0.625rem;
    align-items: center;
    padding: 0.1875rem 0;
}
.manual-detail-demo__row--checkbox input {
    justify-self: start;
}
.manual-detail-demo__label {
    font-size: 0.75rem;
    line-height: 1.3;
    opacity: 0.8;
}
.manual-detail-demo__input {
    display: block;
    width: 100%;
    min-height: 1.75rem;
    border: 1px solid rgba(128, 128, 128, 0.35);
    border-radius: 0.375rem;
    padding: 0.25rem 0.5rem;
    font-size: 0.8125rem;
    line-height: 1.3;
}
</style>
